import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PortalButtonComponent } from '../portal-button/portal-button.component';

@Component({
  selector: 'app-portal-select-device-type',
  imports: [PortalButtonComponent],
  templateUrl: './portal-select-device-type.component.html',
  styleUrl: './portal-select-device-type.component.css',
})
export class PortalSelectDeviceTypeComponent {
  router = inject(Router);

  navigateToThuisLogin() {
    //TODO:
    //activate as home device
    // go to route "loginToHomeDevice"
    this.router.navigate(['/loginToHomeDevice']);
  }

  navigateToSchoolActivation() {
    this.router.navigate(['/activate']);
  }
}
